import SchemaMarkup from "../Components/SchemaMarkup";

const WebsiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",

    "@id": "https://msayurved.com/#website",

    "url": "https://msayurved.com/",

    "name": "Dr. Jigar Gor's Ayurveda",

    "description":
      "Official website of Dr. Jigar Gor's Ayurveda providing Ayurvedic consultations, treatments, and healthcare information.",

    "publisher": {
      "@id": "https://msayurved.com/#organization"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default WebsiteSchema;